<template lang="pug">
el-dialog(v-dialogDrag
  :close-on-click-modal="false",
  :close-on-press-escape="false"
  :visible.sync="logDialog"
  width="1200px"
  :before-close="handleClose")
  template(#title)
    .dialog-title
      .title {{logTitle}}
      .right
        el-button(size="small" type="primary" :disabled="!selectionList.length" @click="exportFlowApplicationHistory") 导出
  .header-midd
    el-form(ref="logForm" :model="logForm" size="small" inline)
      el-form-item(label="审批状态")
        el-select(v-model="logForm.status" size="small" clearable)
          el-option(v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value")
      el-form-item(label="申请人")
        el-select(v-model="logForm.flowInstanceOwnerId" size="small" clearable)
          el-option(v-for="item in userList" :key="item.flowInstanceOwnerID" :label="item.flowInstanceOwnerName" :value="item.flowInstanceOwnerID")
      el-form-item(label="申请时间")
        el-date-picker(v-model="logForm.createTime" type="daterange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" size="small" :default-time="['00:00:00', '23:59:59']")
      el-form-item
        el-button(size="small" type="primary" @click="queryBtnClick") 查 询
        el-button(size="small" type="primary" plain @click="resetForm") 重 置
  .bottom-table
    el-table(
      border
      :data="definitionTable"
      ref="multipleTable"
      v-loading="loading"
      element-loading-text="数据加载中"
      @selection-change="handleSelectionChange"
      height="500")
      el-table-column(type="selection" width="55" align="center")
      el-table-column(type="index" label="编号" align="center" width="60")
      el-table-column(label="状态" prop="status" width="90px" align="center" v-slot="{row}")
        span.flowStatus(:class="`type${row.status}`") {{statusName(row.status)}}
      el-table-column(label="流程类型" prop="flowType" min-width="80px" align="center")
      el-table-column(label="标题" sortable prop="title" min-width="120px" v-slot="{row}")
        el-link(type="primary" @click="viewProcess(row, 'view')")
          span(class="tabLinkSpan" :title='row.title') {{ row.title }}
      el-table-column(label="内容" sortable prop="content" min-width="100px" show-overflow-tooltip)
      el-table-column(label="申请人" prop="flowInstanceOwnerName" min-width="100px" align="center")
      el-table-column(label="申请时间" prop="flowInstanceStartTime" min-width="100px" show-overflow-tooltip)
      el-table-column(label="操作"  min-width="100px" v-slot="{row}")
        el-button.btn-text(type="text"  @click.stop="viewProcess(row,'view')") 查看
        el-button.btn-text(type="text" v-if="row.status === 2" @click.stop="rejectAdmin(row)") 驳回
        el-button.btn-text(type="text" v-if="row.status === 2" @click.stop="terminationAdmin(row)") 终止
        el-button.btn-text(type="text" v-if="row.status === 2" @click.stop="passAdmin(row)") 通过
  .page
    el-pagination(
      :current-page.sync="page.pageNum"
      :page-size="page.pageSize"
      :layout="page.pageLayout"
      :total="page.totalCount"
      v-if="page.totalCount > 0"
      :page-sizes="[10, 20, 50, 100]"
      size="small"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange")
</template>

<script>
import flowService from "@/CommonDP/service/flow-service";
import { mapState } from "vuex";
import { openFlow } from "@/CommonDP/components/processComponents/flowNew/index.js";
import { exportFile } from "@/CommonDP/utils/file";
import { getStatusName, FLOW_INSTANCE_STATUS_ALL_DICT } from "@/CommonDP/components/processComponents/config";

const initSearchForm = () => ({
  status: "",
  flowInstanceOwnerId: "", // 申请人 fullscreen
  createTime: []
});
export default {
  data () {
    return {
      logTitle: "流程",
      logDialog: false,
      logForm: initSearchForm(),
      statusName: getStatusName,
      statusList: FLOW_INSTANCE_STATUS_ALL_DICT,
      page: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0,
        pageLayout: "total, sizes,prev, pager, next,jumper" // 分页组件
      },
      userList: [],
      definitionTable: [],
      selectionList: [],
      loading: false,
      flowDefinitionId: ""
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    }),
    logParams() {
      return {
        ...this.logForm,
        startDate: this.logForm.createTime[0],
        endDate: this.logForm.createTime[1],
        enterpriseId: this.enterpriseId,
        flowVersion: this.flowDefinitionId
      };
    }
  },
  methods: {
    openDialog(row) {
      this.logTitle = row.flowName + " 审批记录";
      this.flowDefinitionId = row.flowDefinitionId;
      this.getUserList();
      this.getHistoryList();
      this.logDialog = true;
    },
    async getUserList() {
      const res = await flowService.getApprovalRecordList(this.enterpriseId, this.flowDefinitionId);
      this.userList = res.data || [];
    },
    // 获取历史记录
    async getHistoryList() {
      const { page: { pageSize, pageNum }} = this;
      this.loading = true;
      const res = await flowService.getHistoryList(pageNum, pageSize, this.logParams);
      this.definitionTable = res.data || [];
      this.page.totalCount = res.totalCount;
      this.page.pageNum = res.pageIndex;
      this.loading = false;
    },
    // 查看
    async viewProcess(row, approveType) {
      const { currentVersionId = "", flowInstanceId = "" } = row;
      const data = { currentVersionId, flowInstanceId, approveType, enterpriseId: this.enterpriseId };
      openFlow(data);
    },
    // 驳回流程
    async rejectAdmin(row) {
      await this.$confirm(`您确定驳回当前流程吗?`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      const { flowInstanceId } = row;
      await flowService.rejectAdmin({ flowInstanceId });
      this.$message.success("请求成功");
      this.getHistoryList();
    },
    // 终止流程
    async terminationAdmin(row) {
      await this.$confirm(`您确定终止当前流程吗?`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      // const form = Vue.observable({ remark: "", verify: false });
      // const FContent = {
      //   render() {
      //     return (
      //       <div>
      //         <ElInput vModel={form.remark} size='mini' type='textarea' autosize={ { minRows: 2, maxRows: 6 }}
      //           show-word-limit placeholder='请输入终止原因' />
      //         {form.verify ? <div style='color:#ff0000;'>请输入终止原因</div> : undefined}
      //       </div>
      //     );
      //   }
      // };
      // await this.$msgbox({
      //   title: "终止流程",
      //   message: <FContent />,
      //   showCancelButton: true,
      //   beforeClose: (action, instance, done) => {
      //     if (action === 'confirm') {
      //       if (!form.remark) form.verify = true;
      //       else { done(); }
      //     } else { done(); }
      //   }
      // });
      const { flowInstanceId } = row;
      const params = {
        flowInstanceId
      //  remark: form.remark
      };
      await flowService.terminationAdmin(params);
      this.$message.success("请求成功");
      this.getHistoryList();
    },
    // 通过流程
    async passAdmin(row) {
      await this.$confirm(`您确定通过流程吗?`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      const { flowInstanceId } = row;
      await flowService.passAdmin({ flowInstanceId });
      this.$message.success("请求成功");
      this.getHistoryList();
    },
    // 查询
    queryBtnClick() {
      this.page.pageNum = 1;
      this.getHistoryList();
    },
    // 重置
    resetForm() {
      this.logForm = initSearchForm();
      this.page.pageNum = 1;
      this.getHistoryList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getHistoryList();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getHistoryList();
    },
    updateTable() {
      this.getHistoryList();
    },
    handleSelectionChange(val) {
      this.selectionList = val;
    },
    async exportFlowApplicationHistory() {
      const params = {
        ...this.logParams,
        ids: this.selectionList.map(e => e.flowBusinessId)
      };
      await exportFile(flowService.exportFlowApplicationHistory(params), "审批历史.xlsx");
      this.$refs.multipleTable.clearSelection();
    },
    handleClose() {
      this.logDialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: 50px;

  .title {
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
  }

  .right {
    margin-left: auto;
    display: flex;
    flex-direction: row;
    align-items: center;

    .el-button {
      margin-left: 5px;
    }
  }
}

.page {
  padding: var(--middle-space, 12px) 0 var(--small-space, 8px);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.flowStatus {
  border-radius: 6px;
  text-align: center;
  padding: 2px 8px;
}
.type1,.type4{
  border: 1px solid #10A667;
  background: rgba(16, 166, 103, 0.10);
  color: #10A667;
}

.type2 {
  border: 1px solid #FF7A00;
  background: rgba(255, 122, 0, 0.10);
  color: #FF7A00;
}

.type3 {
  border: 1px solid #60656B;
  background: rgba(96, 101, 107, 0.10);
  color: #60656B;
}

.type8 {
  border: 1px solid #9746E8;
  background: rgba(151, 70, 232, 0.10);
  color: #9746E8;
}

.type9 {
  border: 1px solid #2F8BF8;
  background: rgba(47, 139, 248, 0.10);
  color: #2F8BF8
}

.type0 {
  border: 1px solid #FF4A4A;
  background: rgba(255, 74, 74, 0.10);
  color: #FF4A4A;
}
.btn-text{
  margin-left: 0px;
}
</style>
